import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { PrereqItem } from '@/hooks';

interface EmailSendPrereqNoticeProps {
  items: PrereqItem[];
}

// Warns the RM about employee-owned prerequisites they must complete before an
// email can be sent (e.g. Employee Code). Renders nothing when all are met.
export function EmailSendPrereqNotice({ items }: EmailSendPrereqNoticeProps) {
  if (items.length === 0) return null;

  return (
    <div className="rounded-lg border border-warning/40 bg-warning/10 p-3">
      <div className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <AlertTriangle className="h-4 w-4 text-warning" />
        Complete this before sending
      </div>
      <ul className="mt-1.5 flex flex-col gap-1 pl-6 text-xs text-foreground/80">
        {items.map((item) => (
          <li key={item.label} className="list-disc">
            {item.message}{' '}
            <Link to={item.to} className="font-semibold text-brand underline">
              Go to Profile
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
